import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DateCellStyling,ContainerStyling,HeadingStyling,ContentCellStyling,TableStyling,TableRowStyling} from './BiogTableStyles';

export default function BiogCatalogs(props) {
  const { t } = useTranslation('common');

  return (
     <>
    <Grid2 flexDirection="row" sx={ContainerStyling}>
        <TableContainer>
          <Table sx={TableStyling} aria-label="simple table">
            <TableBody>
              {props.catalogs.map((catalog, index) => (
                <TableRow
                  key={catalog.id}
                  sx={TableRowStyling}
                >
                  <TableCell component="td" padding="none" scope="row" sx={DateCellStyling}>
                    {catalog.year}
                  </TableCell>
                  <TableCell align="left" padding="none" sx={ContentCellStyling}>
                    <Box sx={{fontWeight : 'bold'}} component='span'>{catalog.name}</Box>
                    {!!(catalog.institution)?<Box sx={{fontWeight : 'normal'}} component='span'> - {catalog.institution}</Box>:null}
                    {!!(catalog.location)?<Box sx={{fontWeight : 'normal'}} component='span'>, {catalog.location}</Box>:null}                   
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid2>
    </>
  )
}
